import { createGlyphIcon } from '@eleventheye/asui';

const fontFamily = 'Material Symbols Rounded';

export const RefreshIcon = createGlyphIcon({
  glyph: 'refresh',
  fontFamily,
  weight: 300,
});

export const HeadToHeadIcon = createGlyphIcon({
  glyph: 'view_compact',
  fontFamily,
  weight: 500,
});

export const FinanceIcon = createGlyphIcon({
  glyph: 'finance',
  fontFamily,
  weight: 500,
});

export const FinanceModeIcon = createGlyphIcon({
  glyph: 'finance_mode',
  fontFamily,
  weight: 500,
});

export const FootballIcon = createGlyphIcon({
  glyph: 'sports_football',
  fontFamily,
  weight: 500,
});

export const SwordsIcon = createGlyphIcon({
  glyph: 'swords',
  fontFamily,
  weight: 500,
});

export const StandingsIcon = createGlyphIcon({
  glyph: 'leaderboard',
  fontFamily,
  weight: 500,
});

export const ScheduleIcon = createGlyphIcon({
  glyph: 'calendar_month',
  fontFamily,
  weight: 500,
});

export const TrendingUpIcon = createGlyphIcon({
  glyph: 'trending_up',
  fontFamily,
  weight: 300,
});

export const TrendingDownIcon = createGlyphIcon({
  glyph: 'trending_down',
  fontFamily,
  weight: 300,
});

export const TrendingFlatIcon = createGlyphIcon({
  glyph: 'trending_flat',
  fontFamily,
  weight: 300,
});

export const ErrorIcon = createGlyphIcon({
  glyph: 'error',
  fontFamily,
  weight: 300,
});

export const HotIcon = createGlyphIcon({
  glyph: 'local_fire_department',
  fill: 1,
  fontFamily,
  weight: 300,
});

export const ColdIcon = createGlyphIcon({
  glyph: 'ac_unit',
  fontFamily,
  weight: 300,
});
